import { Card } from "@material-ui/core";
import { useState } from "react";

import classes from "./index.module.css";

const Collapse = ({ title, titleIcon, children, defaultOpen }) => {
  const [open, setOpen] = useState(!!defaultOpen);

  return (
    <Card
      className={classes.root}
      {...(open && { style: { boxShadow: "none" } })}>
      <div className={classes.header}>
        <div className={classes.flexAlignCenter}>
          {titleIcon && <span className={classes.titleIcon}>{titleIcon}</span>}
          <span className={classes.title}>
            {typeof title === "function" ? title(open) : title}
          </span>
        </div>
        {open && (
          <span className={classes.openIcon} onClick={() => setOpen(false)}>
            <i className="fas fa-caret-down"></i>
          </span>
        )}
        {!open && (
          <span className={classes.openIcon} onClick={() => setOpen(true)}>
            <i className="fas fa-caret-right"></i>
          </span>
        )}
      </div>
      <div
        className={classes.content}
        style={{ display: open ? "block" : "none" }}>
        {children}
      </div>
    </Card>
  );
};

export default Collapse;
